































































































































import { Component, Vue } from "vue-property-decorator";
import request from "@/api/wanzhou/index";
import Base from "@/template/public/Base.vue";
import { IVideoDetail } from "@/api/wanzhou/types";
import { IShareConfig, IShareConfigItem } from "@/api/types";
// import { AppInfo } from "@/common/baseConfig";
import Zan from "@/components/Zan.vue";
import native from "@/common/Native";
import AppPrompt from "@/components/AppPrompt.vue";
import { wxChatShare } from "@/common/wechat";
import { Loading } from "vant";
import { setImgSrc, findNameByIdInApp } from "@/common/Utils";
import nopage from "@/components/404.vue";
import ImageViewCom from "@/components/imageViewCom.vue";
import Poster from "@/components/Poster.vue";
import { getData, time } from "@/common/dataCollect";
@Component({
  components: {
    Zan,
    AppPrompt,
    VanLoading: Loading,
    nopage,
    ImageViewCom,
    Poster
  }
})
export default class VideoPage extends Base {
  public request = new request();
  private videoDetail: any = {};
  private downloadUrl: string = "";
  private appName: string = "";
  public appId: string = "";
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  private businessDetail: any = {
    isPraised: "",
    viewCount: "",
    praiseCount: "",
    replyCount: ""
  };
  private isOpenInApp: boolean = false;
  private isRequestLoaded: boolean = false; //详情是否加载完成
  ImgSrcArr: any = [];
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  created() {
    this.startTime = time();
  }
  mounted() {
    //假的userInfo
    // this.userInfo = {
    //   appId: "28",
    //   sessionId: "68ad409040054938b4e53e5612a8124c",
    //   token: "03d24c7f4c6a48f3af3d667d8d1aca4a",
    // };
    this.infoClassifyId = this.$route.query.id
      ? (this.$route.query.id as string)
      : (this.$route.query.cid as string) || "2273453";
    this.appId = (this.$route.query.appId as string) || "28";
    // this.appName = AppInfo[Number(this.appId)]; //enum 反向映射
    this.appName = findNameByIdInApp(this.$store.state.appInfo, this.appId); //enum 反向映射
    //获取用户详情
    if (native.isOpenInApp()) {
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
        this.getDetail();
        this.isOpenInApp = true;
      });
    } else {
      this.getDetail();
      this.isOpenInApp = false;
    }
  }
  getDetail() {
    this.request
      .getActNewsInfo(this.infoClassifyId)
      .then((response: IVideoDetail) => {
        this.isRequestLoaded = true;
        if (response.code >= 0) {
          this.videoDetail = response.data;
          document.title = this.videoDetail.title;
          this.$nextTick(() => {
            setImgSrc(this.$refs.newsContent as Element);
            this.handleVideo();
            this.imageHandle(); // 图片预览等功能
          });

          this.getBussinessDetail();
          this.getCount();
          // 唤醒头部 赋值base.vue里detailGetAppId参数值
          this.getBaseappInfoConfigList(this.videoDetail.appId);
          this.detailGetAppId = this.videoDetail.appId;
          this.$nextTick(() => {
            // 埋点
            this.endTime = time();
            if (this.dataSource) {
              getData(this.startTime, this.endTime, this.videoDetail);
              this.dataSource = false;
            }
          });
        }
      })
      .catch(() => {
        this.getShareInfo(this.appId);
        this.isRequestLoaded = true;
      });
  }
  // 图片处理
  openViewChild(index: any) {
    const el = this.$refs.ImageViewCom as any;
    el.openView(index);
  }
  imageHandle() {
    const elements: Array<HTMLElement> = Array.prototype.slice.call(
      document.querySelectorAll(".news-content img") as NodeListOf<HTMLElement>,
      0
    );
    const srcArr: Array<string> = elements.map(
      v => v.getAttribute("data-original") as string
    );
    this.ImgSrcArr = srcArr;
    let th = this;
    elements.forEach((v, i) => {
      (function(i) {
        v &&
          v.addEventListener(
            "click",
            function(e) {
              th.openViewChild(i);
            },
            false
          );
      })(i);
    });
  }
  /**业务详情 */
  getBussinessDetail() {
    this.request
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        // this.newsInfo.informationId,
        this.infoClassifyId,
        "1",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response.code >= 0) {
          // this.businessDetail = response.data;
          wxChatShare(
            response.data.detailTitle,
            response.data.shareDescription,
            response.data.shareUrlWx,
            response.data.shareImgUrl
          );
        }
      });
  }
  getCount() {
    // 在app外才需要增加浏览量 接口做了ua判断不需要前端判断是否在app内
    this.request.getCount(this.appId, this.infoClassifyId).then((res: any) => {
      if (res.code >= 0 && res.data) {
        this.businessDetail.viewCount = res.data.showViewCount;
        this.businessDetail.praiseCount = res.data.showPraiseCount;
        this.businessDetail.replyCount = res.data.showReplyCount;
      }
    });
  }
  // getShareInfo() {
  //   this.request
  //     .getShareInfoMethod(this.appId)
  //     .then((response: IShareConfig) => {
  //       if (response.code >= 0) {
  //         this.shareInfo = response.data;
  //         this.downloadUrl = this.shareInfo.downloadUrl;
  //       }
  //     });
  // }
  // makePoster() {
  //   //canvas转Blob
  //   let video: any = this.$refs.video;
  //   let dataURLtoBlob = function(dataurl: any) {
  //     let arr = [];
  //     arr = dataurl.split(",");
  //     let mime = arr[0].match(/:(.*?);/)[1],
  //       bstr = atob(arr[1]),
  //       n = bstr.length,
  //       u8arr = new Uint8Array(n);
  //     while (n--) {
  //       u8arr[n] = bstr.charCodeAt(n);
  //     }
  //     return new Blob([u8arr], { type: mime });
  //   };
  //   console.log(video);
  //   let scale: number = 0.7; //截图绽放比例
  //   let canvas: any = document.createElement("canvas");
  //   canvas.width = video.videoWidth * scale;
  //   canvas.height = video.videoHeight * scale;
  //   canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
  //   console.log(canvas);
  //   let imgsrc = canvas.toDataURL("image/jpeg", 0.8); //第二个参数指图片质量
  //   console.log(imgsrc);
  //   // let poster = dataURLtoBlob(imgsrc); //这是我们要上传的封面图片
  //   console.log(imgsrc);
  //   // console.log(poster);
  // }
}
